import React from 'react'

import { Table, Button } from '_zari/core'

import { IdGen } from 'utils'
import { DhContabilidadConstant } from 'constants/index'

const DetallesMovimientos = ({ item, index }) => {
  const colorSeleccionado = '#ffd800'
  const [verDetalleBalance, setVerDetalleBalance] = React.useState(false)
  const [filaActiva, setFilaActiva] = React.useState('0')

  const filtrosRef = React.useRef({})

  const [fila1, setFila1] = React.useState('')
  const [fila2, setFila2] = React.useState('')
  const [fila3, setFila3] = React.useState('')
  const [fila4, setFila4] = React.useState('')
  const [fila5, setFila5] = React.useState('')
  const [fila6, setFila6] = React.useState('')

  const clickVerDetalleBalance = React.useCallback(
    ({ codigo, seccion, tipo, fila }) => {
      if (verDetalleBalance === true) {
        setVerDetalleBalance(false)
        setFilaActiva('0')
        switch (fila) {
          case '1':
            setFila1('')
            break
          case '2':
            setFila2('')
            break
          case '3':
            setFila3('')
            break
          case '4':
            setFila4('')
            break
          case '5':
            setFila5('')
            break
          case '6':
            setFila6('')
            break
          default:
            break
        }
      } else {
        filtrosRef.current = { codigo, seccion, tipo }
        setFilaActiva(fila)
        setVerDetalleBalance(true)
        switch (fila) {
          case '1':
            setFila1(colorSeleccionado)
            break
          case '2':
            setFila2(colorSeleccionado)
            break
          case '3':
            setFila3(colorSeleccionado)
            break
          case '4':
            setFila4(colorSeleccionado)
            break
          case '5':
            setFila5(colorSeleccionado)
            break
          case '6':
            setFila6(colorSeleccionado)
            break
          default:
            break
        }
      }
    },
    [verDetalleBalance]
  )

  return (
    <>
      <tr key={index}>
        <td className='text-center'>{item.codigoCuenta}</td>
        <td className='text-center'>{item.descripcion}</td>
        <td style={{ backgroundColor: fila1 }}>
          {(filaActiva === '1' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'saldos iniciales', tipo: 'debe', fila: '1' })}
            >
              v
            </Button>
          )}
          {item.totalDebeApertura}
        </td>
        <td style={{ backgroundColor: fila2 }}>
          {(filaActiva === '2' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'saldos iniciales', tipo: 'haber', fila: '2' })}
            >
              v
            </Button>
          )}
          {item.totalHaberApertura}
        </td>
        <td style={{ backgroundColor: fila3 }}>
          {(filaActiva === '3' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'movimientos', tipo: 'debe', fila: '3' })}
            >
              v
            </Button>
          )}
          {item.sumaDebe}
        </td>
        <td style={{ backgroundColor: fila4 }}>
          {(filaActiva === '4' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'movimientos', tipo: 'haber', fila: '4' })}
            >
              v
            </Button>
          )}
          {item.sumaHaber}
        </td>
        <td style={{ backgroundColor: fila5 }}>
          {(filaActiva === '5' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'saldos finales', tipo: 'debe', fila: '5' })}
            >
              v
            </Button>
          )}
          {item.filaConglomerado === DhContabilidadConstant.DEBE ? item.totalConglomerado : '--'}
        </td>
        <td style={{ backgroundColor: fila6 }}>
          {(filaActiva === '6' || filaActiva === '0') && (
            <Button
              tiny
              outline
              style={{ marginRight: '10px' }}
              onClick={e => clickVerDetalleBalance({ codigo: item.codigoCuenta, seccion: 'saldos finales', tipo: 'haber', fila: '6' })}
            >
              v
            </Button>
          )}
          {item.filaConglomerado === DhContabilidadConstant.HABER ? item.totalConglomerado : '--'}
        </td>
      </tr>
      {verDetalleBalance && filaActiva !== '0' && (
        <tr key={IdGen.newId()}>
          <td colSpan='8'>
            <Table.ServerSide
              useNest={true}
              useFilters={true}
              headRows={[
                { label: 'Cuenta', align: 'center' },
                { label: 'Fecha', align: 'center' },
                { label: 'Glosa', align: 'center' },
                { label: 'Moneda', align: 'center' },
                { label: 'M. N.', align: 'center' },
                { label: 'M. E.', align: 'center' },
                { label: 'Tipo', align: 'center' },
                {
                  label: 'Serie',
                  align: 'center',
                  width: 70,
                  filter: {
                    type: 'text',
                    name: 'serDoc'
                  }
                },
                {
                  label: 'Numero',
                  align: 'center',
                  width: 90,
                  filter: {
                    type: 'text',
                    name: 'numDoc'
                  }
                },
                {
                  label: 'RUC',
                  align: 'center',
                  width: 110,
                  filter: {
                    type: 'text',
                    name: 'ruc'
                  }
                },
                { label: 'Razon Social', align: 'center' }
              ]}
              url='/asientos-contables/detalle-balance'
              baseParams={filtrosRef.current}
              rowsPerPage={5}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell align='center'>{row.cuentaContable || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                  <Table.Cell>{row.glosa || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.moneda || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.montoNacional || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.montoExtranjero || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.tipoDocumento || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                  <Table.Cell align='center'>{row.ruc || '--'}</Table.Cell>
                  <Table.Cell>{row.razonSocial || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </td>
        </tr>
      )}
    </>
  )
}

export default React.memo(DetallesMovimientos)
